import { render } from "./SectionSelectorModal.vue?vue&type=template&id=39846330&scoped=true"
import script from "./SectionSelectorModal.vue?vue&type=script&lang=js"
export * from "./SectionSelectorModal.vue?vue&type=script&lang=js"

import "./SectionSelectorModal.vue?vue&type=style&index=0&id=39846330&lang=css"
import "./SectionSelectorModal.vue?vue&type=style&index=1&id=39846330&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39846330"]])

export default __exports__